import { Component, Input } from '@angular/core';

@Component({
  selector: 'hb-action-header',
  templateUrl: './action-header.component.html',
  styleUrls: ['./action-header.component.scss'],
})
export class ActionHeaderComponent {
  @Input() headerText: string = '';
  @Input() headerType: 'title' | 'subtitle' = 'title';
}
